import HelpPage from "./HelpPage";

export default HelpPage;